function showStatusMessage(): void {
    const spanElement: HTMLSpanElement | null = document.querySelector('.source-reference__copied-message');

    if (spanElement) {
        const text: string = spanElement.dataset.text || '';
        spanElement.textContent = text;
        spanElement.classList.remove('sr-only');

        setTimeout(() => {
            spanElement.classList.add('sr-only');
            spanElement.textContent = '';
        }, 3000);
    }
}

function copyToClipboard() {
    const sourceReference = document.querySelector('.source-reference__content');
    if (!sourceReference) return;

    // Extract and format the content properly
    const textToCopy = formatSourceReference(sourceReference);

    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy);
    } else {
        fallbackCopyText(textToCopy);
    }

    showStatusMessage();
}

// Function to extract and format the reference content
function formatSourceReference(element: Element): string {
    const author = element.querySelector('.source-reference__text')?.childNodes[0]?.textContent?.trim();
    const date = element.querySelector('.source-reference__date')?.textContent?.trim();
    const title = element.querySelector('.source-reference__title')?.textContent?.trim();
    const url = element.querySelector('.source-reference__url')?.textContent?.trim();

    if (!author || !date || !title || !url) {
        return 'Cannot copy source reference.';
    }

    return `${author} ${date} ${title} \n${url}`;
}

// Alternative copy method for iOS (uses input field since iOS restricts clipboard access)
function fallbackCopyText(text: string) {
    const input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999); // For iOS compatibility

    navigator.clipboard.writeText(input.value);

    document.body.removeChild(input);
}

document.addEventListener('DOMContentLoaded', () => {
    const copyButton = document.querySelector('.source-reference__copy-button');
    if (copyButton) {
        copyButton.addEventListener('click', copyToClipboard);
    }
});